<template>
  <div>
    <div v-if="ordreTravail.demandesLogistique.length === 0
      && !ordreTravail.demandeImpressionId">
      <div class="card mgt-20px">
        <div class="card-content has-text-centered pd-40px">
          <h1 class="title is-size-3">
            {{ $t('detailOrdreTravailTech.demandeLiee.noDemande')}}
          </h1>
        </div>
      </div>
    </div>
    <div v-else-if="ordreTravail.demandesLogistique.length === 0
      && ordreTravail.demandeImpressionId && demandeImpression">
        <p class="title is-size-4 mgt-25px">
          <router-link-blank :to="{ name: 'c.logistique.demande_impression',
            params: { id: demandeImpression.id } }"
            :class="{'text-access-no-permission':
            !checkPermissions(constantes.DEMANDE_IMPRESSION.lecture)}"
            :message="$t('detailDemandeImpression.demandeLiee.title')">
          </router-link-blank>
        </p>
        <div class="mgl-3 pdt-0">
          <div class="columns is-multiline">
            <div class="column is-10 pdl-0">
                <informations-generales class="mgt-20px" :demandeImpression="demandeImpression">
                </informations-generales>
                <info-dispositif class="mgt-20px"
                  :demandeImpression="demandeImpression">
                </info-dispositif>
                <info-campagne class="mgt-20px"
                  v-if="moduleCampagneActive"
                  :demandeImpression="demandeImpression">
                </info-campagne>
                <info-commentaire class="mgt-20px"
                  :title="$t('detailDemandeImpression.infoGenerale.description')"
                  :texte="demandeImpression.description">
                </info-commentaire>
                <info-commentaire class="mgt-20px"
                  :title="$t('detailDemandeImpression.infoGenerale.commentaire')"
                  :texte="demandeImpression.commentaire">
                </info-commentaire>
            </div>
            <div class="column is-2 pdt-0">
                <information-create-update-user :data="demandeImpression" class="mgr-20px">
                </information-create-update-user>
            </div>
          </div>
        </div>
    </div>
    <div v-else>
      <div class="card">
        <header class="header-card">
          <p>{{ $t('addEditOrdreTravailTech.demandeLiee.title')}}</p>
        </header>
        <div class="card-content">
          <div class="columns is-multiline">
            <div class="card column is-12 mgb-20px"
                 v-for="(demande, index) in ordreTravail.demandesLogistique"
                 :key="index">
              <info-demande :demande-intervention="demande"
                            :is-detail="true"
                            :ot="ordreTravail">
              </info-demande>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import infoDemande from '@/components/logistique/ordreTravail/tech/addEdit/demande/infoDemande';
import informationsGenerales from '@/components/logistique/demandeImpression/detail/informationsGenerales';
import infoDispositif from '@/components/logistique/demandeImpression/detail/infoDispositif';
import infoCampagne from '@/components/logistique/demandeImpression/detail/infoCampagne';
import infoCommentaire from '@/components/logistique/demandeImpression/detail/infoCommentaire';
import InformationCreateUpdateUser from '@/components/general/informationCreateUpdateUser';
import { get as getDemandeImpression } from '@/api/logistique/demandeImpression';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import messageErreur from '@/services/general/messageErreur';
import { DEMANDE_IMPRESSION } from '@/configuration/logistique/permissionsLogistiqueConf';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';

const Permissions = createNamespacedHelpers('permissions');
const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'LogistiqueOrdreTravailTechniqueDetailDemande',
  props: {
    ordreTravail: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      demandeImpression: null,
      constantes: {
        DEMANDE_IMPRESSION,
      },
    };
  },
  components: {
    infoDemande,
    informationsGenerales,
    infoDispositif,
    infoCampagne,
    InformationCreateUpdateUser,
    infoCommentaire,
    routerLinkBlank,
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    moduleCampagneActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.campagne.key);
    },
  },
  methods: {
    async loadDemandeImpressionInformation() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const demandeImpression = (await getDemandeImpression(this.ordreTravail.demandeImpressionId)
        ).data.result;
        this.demandeImpression = demandeImpression;
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
  },
  async mounted() {
    if (this.ordreTravail.demandesLogistique.length === 0
        && this.ordreTravail.demandeImpressionId) await this.loadDemandeImpressionInformation();
  },
};

</script>
